import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { BLOGS as FALLBACK_BLOGS } from '../mock';

const Blogs = () => {
  const blogs = FALLBACK_BLOGS;
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = useMemo(() => {
    const set = new Set();
    blogs.forEach(b => {
      if (b.category) {
        set.add(b.category);
      }
    });
    return ['All', ...Array.from(set)];
  }, [blogs]);

  const filteredBlogs = useMemo(() => {
    if (selectedCategory === 'All') return blogs;
    return blogs.filter(b => b.category === selectedCategory);
  }, [blogs, selectedCategory]);

  return (
    <main className="bg-[#FFFFFF] min-h-screen">
      {/* Editorial Journal Header */}
      <section className="pt-16 pb-12 lg:pt-24 lg:pb-16 border-b border-[#EEF1E4]">
        <div className="max-w-[800px] mx-auto px-6 text-center">
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1a1a1a] font-normal tracking-tight">
            The Journal
          </h1>
          <p className="mt-4 text-base sm:text-lg text-[#5a5346] font-sans leading-relaxed max-w-xl mx-auto">
            Stories, guides and perspectives from House of Seya.
          </p>
        </div>
      </section>

      {/* Category Navigation & Article Grid */}
      <section className="py-12 lg:py-20">
        <div className="max-w-[1340px] mx-auto px-6 lg:px-10">

          {/* Category Filter Navigation */}
          {categories.length > 1 && (
            <div className="flex items-center justify-start sm:justify-center gap-6 sm:gap-8 border-b border-[#EEF1E4] pb-4 mb-12 sm:mb-16 overflow-x-auto no-scrollbar">
              {categories.map((cat) => {
                const isActive = selectedCategory === cat;
                return (
                  <button
                    key={cat}
                    type="button"
                    onClick={() => setSelectedCategory(cat)}
                    className={`text-xs sm:text-sm font-sans uppercase tracking-wide pb-1 transition-all whitespace-nowrap border-b-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)] ${isActive
                        ? 'border-[#1a1a1a] font-medium text-[#1a1a1a]'
                        : 'border-transparent text-[#7a6a54] hover:text-[#1a1a1a]'
                      }`}
                  >
                    {cat}
                  </button>
                );
              })}
            </div>
          )}

          {/* Article Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 lg:gap-x-10 lg:gap-y-16">
            {filteredBlogs.map((b) => (
              <Link
                key={b.slug}
                to={`/blogs/${b.slug}`}
                className="group flex flex-col h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-green)]"
              >
                <div className="aspect-square w-full overflow-hidden bg-[#FBFBF9] border border-[#EEF1E4] shadow-sm mb-6 relative">
                  <img
                    src={b.image}
                    alt={b.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                </div>

                <div className="flex flex-col flex-grow">
                  {b.category && (
                    <span className="text-xs font-mono uppercase tracking-wider text-[#999959] mb-2 font-medium block">
                      {b.category}
                    </span>
                  )}
                  <h2 className="font-serif text-xl sm:text-2xl text-[#1a1a1a] leading-tight font-normal group-hover:text-[var(--brand-green)] transition-colors mb-3">
                    {b.title}
                  </h2>
                  <p className="text-sm text-[#5a5346] leading-relaxed line-clamp-3 font-sans mb-5 flex-grow">
                    {b.excerpt}
                  </p>
                  <span className="inline-flex items-center text-xs font-sans font-medium text-[#1a1a1a] border-b border-[#1a1a1a] pb-0.5 self-start group-hover:text-[var(--brand-green)] group-hover:border-[var(--brand-green)] transition-colors mt-auto">
                    Read article
                  </span>
                </div>
              </Link>
            ))}
          </div>

        </div>
      </section>
    </main>
  );
};

export default Blogs;

